import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimMillisecond',
  standalone: true
})
export class TrimMillisecondPipe implements PipeTransform {

  transform(value: string): string {
    // Match the 'hh:mm:ss' part of 'hh:mm:ss.SSSSSS'
    const match = value.match(/^(\d{2}:\d{2}:\d{2})/);
    return match ? match[1] : value;
  }

}
